module.exports = __webpack_public_path__ + "img/iconProjectWeightGate.3b5c06a3.svg";